import getTableToItemRelationKey from './getTableToItemRelationKey';
import TableViewConversationRelation from '../store/schema/TableViewConversationRelation';
import { getListViewStore } from '../store/Store';

/**
 * Returns TableViewConversationRelation corresponding to input params from list view store
 * @param conversationId
 * @param tableViewId
 */
export default function getTableConversationRelation(
    conversationId: string,
    tableViewId: string
): TableViewConversationRelation {
    const relationKey = getTableToItemRelationKey(conversationId, tableViewId);
    return getListViewStore().tableViewConversationRelations.get(relationKey);
}
